import React, { useEffect } from "react";
import { Box } from "@mui/material";
import ZForHerMain from "./main";
import Explanation from "./explanation";
import LoanOptions from "./loanOptions";
import Eligibility from "./eligibility";
import LoanSteps from "./loanSteps";
import Testimonials from "./testimonials";
import Cta from "../home/cta";
import Footer from "../../components/footer";

const IndexZForHer = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div style={{ overflowX: "hidden" }}>
			<ZForHerMain />
			<Explanation />
			<Box
				sx={{
					background:
						"linear-gradient(to bottom, #FFFFFF 0%, #F4FDF9 20%, #F7F4EE 45%, #F7F4EE 70%, #FFFFFF 100%)",
				}}
			>
				<LoanOptions />
				<Eligibility />
				<LoanSteps />
			</Box>
			<Testimonials />
			<div style={{ marginTop: "clamp(48px, 6.94vw, 100px)" }}>
				<Cta />
			</div>
			<div>
				<Footer />
			</div>
		</div>
	);
};

export default IndexZForHer;
